import React, { useState, useEffect } from "react";
import Api from "../../../services/api";
import "../../../assets/css/app/monetization.css";
import "../../../assets/css/app/release-intel.css";
import {
  Button,
  Form,
  Row,
  Col,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import {
  Collapse,
  Modal,
  Select,
  Space,
  Input,
  DatePicker,
  Button as AntButton,
} from "antd";
import moment from "moment";

import {
  BarChart,
  Bar,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";

import DateComponent from "../../../components/datepicker";
import Select2Custom from "../../../components/Select2Custom";
import { SaveOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { ColorPicker } from "antd";
import TableContainer from "../../../components/TableContainer";

const { RangePicker } = DatePicker;




const analyticsMetrics = [
  { id: "dau", label: "DAU", selected: true },
  { id: "playTime", label: "Play Time", selected: true },
  { id: "sessions", label: "Sessions", selected: true },
  { id: "attributedInstalls", label: "Attributed Installs", selected: true },
  { id: "accAdRevenue", label: "Acc. Ad Revenue", selected: true },
  { id: "accIapRevenue", label: "Acc. IAP Revenue", selected: true },
  { id: "adRevenue", label: "Ad Revenue", selected: true },
  { id: "iapRevenue", label: "IAP Revenue", selected: true },
  { id: "mImpressions", label: "M-Impressions", selected: true },
  { id: "dailyPaidUsers", label: "Daily Paid Users", selected: true },
  { id: "paidRate", label: "Paid Rate", selected: true },
  { id: "ipdau", label: "IPDAU", selected: true },
  { id: "rpdau", label: "RPDAU", selected: true },
  { id: "gpdau", label: "GPDAU", selected: true },
  { id: "ipdeu", label: "IPDEU", selected: true },
  { id: "rpdeu", label: "RPDEU", selected: true },
  { id: "adRpdau", label: "Ad RPDAU", selected: true },
  { id: "iapRpdau", label: "IAP RPDAU", selected: true },
  { id: "advertisingId", label: "AdvertisingID %", selected: true },
  { id: "rpm", label: "RPM", selected: true },
  { id: "accTotalRevenue", label: "Acc. Total Revenue", selected: true },
  { id: "arppu", label: "ARPPU", selected: true },
  { id: "accPurchases", label: "Acc. Purchases", selected: false },
  { id: "purchases", label: "Purchases", selected: false },
];


const adFormatMetrics = [
  { id: "bannerRpm", label: "Banner RPM", selected: true },
  { id: "bannerIpdau", label: "Banner IPDAU", selected: true },
  { id: "bannerRpdau", label: "Banner RPDAU", selected: true },
  { id: "bannerIpdeu", label: "Banner IPDEU", selected: true },
  { id: "interRpm", label: "Inter. RPM", selected: true },
  { id: "interIpdau", label: "Inter. IPDAU", selected: true },
  { id: "interRpdau", label: "Inter. RPDAU", selected: true },
  { id: "interIpdeu", label: "Inter. IPDEU", selected: true },
  { id: "appOpenRpm", label: "App Open RPM", selected: true },
  { id: "appOpenIpdau", label: "App Open IPDAU", selected: true },
  { id: "appOpenRpdau", label: "App Open RPDAU", selected: true },
  { id: "appOpenIpdeu", label: "App Open IPDEU", selected: true },
  { id: "rewardRpm", label: "Reward. RPM", selected: true },
  { id: "rewardIpdau", label: "Reward. IPDAU", selected: true },
  { id: "rewardRpdau", label: "Reward. RPDAU", selected: true },
  { id: "rewardIpdeu", label: "Reward. IPDEU", selected: true },
  { id: "nativeRpm", label: "Native. RPM", selected: true },
  { id: "nativeIpdau", label: "Native. IPDAU", selected: true },
  { id: "nativeRpdau", label: "Native. RPDAU", selected: true },
  { id: "nativeIpdeu", label: "Native. IPDEU", selected: true },
  { id: "rewardedInterRpm", label: "Rewarded Inter. RPM", selected: true },
  { id: "rewardedInterIpdau", label: "Rewarded Inter. IPDAU", selected: true },
  { id: "rewardedInterRpdau", label: "Rewarded Inter. RPDAU", selected: true },
  { id: "rewardedInterIpdeu", label: "Rewarded Inter. IPDEU", selected: true },
  { id: "mrecRpm", label: "MREC RPM", selected: false },
  { id: "mrecIpdau", label: "MREC IPDAU", selected: false },
  { id: "mrecRpdau", label: "MREC RPDAU", selected: false },
  { id: "mrecIpdeu", label: "MREC IPDEU", selected: false },
  { id: "audioAdsRpm", label: "Audio Ads RPM", selected: false },
  { id: "audioAdsIpdau", label: "Audio Ads IPDAU", selected: false },
  { id: "audioAdsRpdau", label: "Audio Ads RPDAU", selected: false },
  { id: "audioAdsIpdeu", label: "Audio Ads IPDEU", selected: false },
  { id: "collapsibleRpm", label: "Collapsible. RPM", selected: false },
  { id: "collapsibleIpdau", label: "Collapsible. IPDAU", selected: false },
  { id: "collapsibleRpdau", label: "Collapsible. RPDAU", selected: false },
  { id: "collapsibleIpdeu", label: "Collapsible. IPDEU", selected: false },
  { id: "inGameRpm", label: "In-game RPM", selected: false },
  { id: "inGameIpdau", label: "In-game IPDAU", selected: false },
  { id: "inGameRpdau", label: "In-game RPDAU", selected: false },
  { id: "inGameIpdeu", label: "In-game IPDEU", selected: false },
];

const MetricButton = ({ metric, onClick }) => {
  if (!metric) {
    return null; 
  }
  
  return (
    <AntButton
      type={metric.selected ? "primary" : "default"}
      className={`metric-btn ${metric.selected ? "selected" : ""}`}
      onClick={() => onClick(metric.id)}
      style={{ width: '160px' }}
    >
      {metric.label}
    </AntButton>
  );
};

const dayOptions = [
  { value: "D0", label: "D0" },
  { value: "D1", label: "D1" },
  { value: "D3", label: "D3" },
  { value: "D7", label: "D7" },
  { value: "D14", label: "D14" },
  { value: "D15", label: "D15" },
  { value: "D30", label: "D30" },
];

const MetricsSection = ({
  analyticsMetrics,
  adFormatMetrics,
  onMetricToggle,
  rrDays,
  setRrDays,
  iapDays,
  setIapDays,
  adDays,
  setAdDays,
  ltvDays,
  setLtvDays,
  onOpenEditModal,
  customMetrics,
  setActiveCustomMetric,
  setAddVisible,
}) => {
  const handleRrDaysChange = (selected) => {
    setRrDays(selected || []);
  };

  const handleIapDaysChange = (selected) => {
    setIapDays(selected || []);
  };

  const handleAdDaysChange = (selected) => {
    setAdDays(selected || []);
  };

  const handleLtvDaysChange = (selected) => {
    setLtvDays(selected || []);
  };
  return (
    <div className="metrics-section">
      <div className="metrics-group">
        <h6>Analytics & Attribution:</h6>
        <div className="metrics-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(9, 160px)', gap: '8px', justifyContent: 'start' }}>
          {analyticsMetrics.map((metric) => (
            <MetricButton
              key={metric.id}
              metric={metric}
              onClick={onMetricToggle}
            />
          ))}
        </div>
      </div>

      <div className="metrics-group">
        <h6>Ad Format:</h6>
        <div className="metrics-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 160px)', gap: '8px', gridTemplateRows: 'repeat(10, auto)', justifyContent: 'start' }}>
          {/* Row 1 - Banner */}
          <div style={{ gridColumn: '1', gridRow: '1' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '1' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '1' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '1' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '1' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'bannerRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 2 - Interstitial */}
          <div style={{ gridColumn: '1', gridRow: '2' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'interRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '2' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'interIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '2' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'interRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '2' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'interIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '2' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'interRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 3 - App Open */}
          <div style={{ gridColumn: '1', gridRow: '3' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '3' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '3' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '3' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '3' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'appOpenRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 4 - Rewarded */}
          <div style={{ gridColumn: '1', gridRow: '4' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '4' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '4' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '4' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '4' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 5 - Native */}
          <div style={{ gridColumn: '1', gridRow: '5' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '5' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '5' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '5' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '5' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'nativeRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 6 - Rewarded Interstitial */}
          <div style={{ gridColumn: '1', gridRow: '6' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '6' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '6' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '6' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '6' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'rewardedInterRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 7 - MREC */}
          <div style={{ gridColumn: '1', gridRow: '7' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '7' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '7' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '7' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '7' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'mrecRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 8 - Audio Ads */}
          <div style={{ gridColumn: '1', gridRow: '8' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '8' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '8' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '8' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '8' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'audioAdsRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 9 - Collapsible */}
          <div style={{ gridColumn: '1', gridRow: '9' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '9' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '9' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '9' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '9' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'collapsibleRpdeu')} onClick={onMetricToggle} />
          </div>
          
          {/* Row 10 - In-game */}
          <div style={{ gridColumn: '1', gridRow: '10' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameRpm')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '2', gridRow: '10' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameIpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '3', gridRow: '10' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameRpdau')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '4', gridRow: '10' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameIpdeu')} onClick={onMetricToggle} />
          </div>
          <div style={{ gridColumn: '5', gridRow: '10' }}>
            <MetricButton metric={adFormatMetrics.find(m => m.id === 'inGameRpdeu')} onClick={onMetricToggle} />
          </div>
        </div>
      </div>

            <div className="metrics-config">
                {/* Row 1 - Ad Format IPDAU/RPDAU */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Banner IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Banner RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Inter. IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Inter. RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>

                {/* Row 2 - App Open & Reward */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>App Open IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>App Open RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Reward. IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Reward. RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>

                {/* Row 3 - Native & Rewarded Inter */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Native. IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Native. RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Rewarded Inter. IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Rewarded Inter. RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>

                {/* Row 4 - MREC & Audio Ads */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>MREC IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>MREC RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Audio Ads IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Audio Ads RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>

                {/* Row 5 - Collapsible & In-game */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Collapsible. IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Collapsible. RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>In-game IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>In-game RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>

                {/* Row 6 - General Metrics */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>IPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>RPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>GPDAU:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>RPM:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>

                {/* Row 7 - Retention Rate & LTV Metrics */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Retention Rate (RR):</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            value={rrDays}
                            onChange={handleRrDaysChange}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>IAP LTV:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            value={iapDays}
                            onChange={handleIapDaysChange}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Ad LTV:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            value={adDays}
                            onChange={handleAdDaysChange}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>LTV:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            value={ltvDays}
                            onChange={handleLtvDaysChange}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>

                {/* Row 8 - Play Time */}
                <div className="config-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px', flex: '0 1 auto' }}>
                        <label style={{ whiteSpace: 'nowrap' }}>Play Time:</label>
                        <Select
                            mode="multiple"
                            options={dayOptions}
                            placeholder="Select Days"
                            style={{ minWidth: '160px', width: 'auto' }}
                            allowClear
                        />
                    </div>
                </div>
            </div>

      <div className="custom-metrics">
        <h6 style={{ fontWeight: 'bold', marginBottom: '16px' }}>Custom Metrics:</h6>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
          {customMetrics.map((m, idx) => (
            <AntButton
              key={idx}
              type={m.active ? "primary" : "default"}
              style={{ 
                minWidth: '160px', 
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '4px 12px',
                borderRadius: '6px',
                border: m.active ? 'none' : '1px solid #d9d9d9'
              }}
              onClick={() => setActiveCustomMetric(idx)}
            >
              <span style={{ 
                color: m.active ? '#fff' : '#595959',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '120px'
              }}>
                {m.label}
              </span>
              <EditOutlined 
                style={{ 
                  color: m.active ? '#fff' : '#8c8c8c',
                  fontSize: '12px',
                  marginLeft: '8px'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onOpenEditModal(idx);
                }}
              />
            </AntButton>
          ))}
          <AntButton
            type="dashed"
            style={{ 
              minWidth: '160px', 
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '4px 12px',
              borderRadius: '6px',
              border: '1px dashed #d9d9d9'
            }}
            onClick={() => setAddVisible(true)}
          >
            <PlusOutlined style={{ fontSize: '12px', marginRight: '4px' }} />
            Add Metric
          </AntButton>
        </div>
      </div>
    </div>
  );
};

const FilterForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    reportName: "New Report",
    startDate: moment("2025-08-19"),
    endDate: moment("2025-08-26"),
    country: [],
    appVersion: [],
    baseVersion: "v2.3.1",
    appVersionSource: "Attribution Service",
  });



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const countryOptions = [
    { value: "vn", label: "Vietnam" },
    { value: "us", label: "United States" },
    { value: "jp", label: "Japan" },
    { value: "kr", label: "Korea" },
    { value: "sg", label: "Singapore" },
  ];

  const appVersionOptions = [
    { value: "v2.3.3", label: "v2.3.3" },
    { value: "v2.3.2", label: "v2.3.2" },
    { value: "v2.3.1", label: "v2.3.1" },
    { value: "v2.2.0", label: "v2.2.0" },
  ];

  const baseVersionOptions = [
    { value: "v2.3.1", label: "v2.3.1" },
    { value: "v2.3.0", label: "v2.3.0" },
    { value: "v2.2.0", label: "v2.2.0" },
  ];

  const appVersionSourceOptions = [
    { value: "Attribution Service", label: "Attribution Service" },
    { value: "App Store", label: "App Store" },
    { value: "Google Play", label: "Google Play" },
  ];

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-header" style={{ marginBottom: '16px' }}>
        <div className="report-name">
          <Select
            className="report-name-select"
            value={formData.reportName}
            onChange={(v) =>
              setFormData((prev) => ({ ...prev, reportName: v }))
            }
            options={[
              { value: "New Report", label: "New Report" },
              { value: "Weekly Report", label: "Weekly Report" },
            ]}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
        <div className="filter-group" style={{ minWidth: '260px' }}>
          <label>Date range:</label>
          <RangePicker
            ranges={{
              'This Week': [moment().startOf('week'), moment().endOf('week')],
              'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
              'This Month': [moment().startOf('month'), moment().endOf('month')],
              'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
              'Last 7 Days': [moment().subtract(7, 'days'), moment()],
              'Last 10 Days': [moment().subtract(10, 'days'), moment()],
              'Last 30 Days': [moment().subtract(30, 'days'), moment()],
            }}
            style={{ width: '100%' }}
          />
        </div>

        <div className="filter-group flex-fill" style={{ minWidth: '260px'}}>
          <label>Country:</label>
          <Space.Compact style={{ width: "100%" }}>
            <Select
              defaultValue="Includes"
              options={[
                { value: "Includes", label: "Includes" },
                { value: "Excludes", label: "Excludes" },
              ]}
              style={{ width: '100px' }}
            />
            <Select
              mode="multiple"
              placeholder="Select country"
              value={formData.country}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, country: value }))
              }
              options={countryOptions}
              style={{ width: '100%' }}
              allowClear
              maxTagCount={1}
              maxTagTextLength={10}
            />
          </Space.Compact>
        </div>

        <div className="filter-group flex-fill" style={{ minWidth: '260px' }}>
          <label>App Version:</label>
          <Space.Compact style={{ width: "100%" }}>
            <Select
              defaultValue="Includes"
              options={[
                { value: "Includes", label: "Includes" },
                { value: "Excludes", label: "Excludes" },
              ]}
              style={{ width: '100px' }}
            />
            <Select
              mode="multiple"
              placeholder="Version"
              value={formData.appVersion}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, appVersion: value }))
              }
              options={appVersionOptions}
              style={{ width: '100%' }}
              allowClear
              maxTagCount={1}
              maxTagTextLength={10}
            />
          </Space.Compact>
        </div>

        <div className="filter-group" style={{ minWidth: '260px' }}>
          <label>Base Version:</label>
          <Select
            value={formData.baseVersion}
            onChange={(value) =>
              setFormData((prev) => ({ ...prev, baseVersion: value }))
            }
            options={baseVersionOptions}
            style={{ width: "100%" }}
          />
        </div>

        <div className="filter-group" style={{ minWidth: '260px' }}>
          <label>App Version Source:</label>
          <Select
            value={formData.appVersionSource}
            onChange={(value) =>
              setFormData((prev) => ({ ...prev, appVersionSource: value }))
            }
            options={appVersionSourceOptions}
            style={{ width: "100%" }}
          />
        </div>

        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-center' , paddingTop: '9px'}}>
          <AntButton
            type="primary"
            htmlType="submit"
            className="run-report-btn"
            style={{ minWidth: '120px' }}
          >
            Run Report
          </AntButton>
          <AntButton 
            type="dashed"
          >
            <SaveOutlined />
          </AntButton>
        </div>
      </div>
    </form>
  );
};

function ReleaseIntel() {
  const [analyticsMetricsState, setAnalyticsMetricsState] =
    useState(analyticsMetrics);
  const [adFormatMetricsState, setAdFormatMetricsState] =
    useState(adFormatMetrics);
  const [metricsExpanded, setMetricsExpanded] = useState(false);
  const [rrDays, setRrDays] = useState([]);
  const [iapDays, setIapDays] = useState([]);
  const [adDays, setAdDays] = useState([]);
  const [ltvDays, setLtvDays] = useState([]);
  const [customMetrics, setCustomMetrics] = useState([
    { label: "Attributed / Ad Network Installs", active: false },
    { label: "IAP percentage", active: false },
    { label: "Total ROAS", active: false },
  ]);
  const [hasRunReportTop, setHasRunReportTop] = useState(false);
  const [hasRunReportMetrics, setHasRunReportMetrics] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [addVisible, setAddVisible] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [showMetricDropdown, setShowMetricDropdown] = useState(false);
  const [selectedMetrics, setSelectedMetrics] = useState([]);
  const [numberInput, setNumberInput] = useState('');
  const [showNumberInput, setShowNumberInput] = useState(false);

  
  const [sortConfig, setSortConfig] = useState({ field: null, direction: null });
  const [showPopup, setShowPopup] = useState(false);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [columnOrder, setColumnOrder] = useState([]);
  const [filters, setFilters] = useState({ searchTerm: "", conditions: {}, expandedFields: {} });
  const [columnFilterPopup, setColumnFilterPopup] = useState({ activeColumn: null, position: { top: 0, left: 0 } });
  const columnPopupRef = React.useRef(null);

  const fields = [];
  const dataTotal = {};
  const sortedData = [];
  const METRIC_FORMATS = {};
  const getVisibleColumns = () => [];
  const toggleSort = () => {};
  const getFieldLabel = (f) => f;
  const hasActiveFilter = () => false;
  const handleColumnFilterClick = (field, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setColumnFilterPopup({ activeColumn: field, position: { top: rect.bottom, left: rect.left } });
  };
  const renderGroup = () => null;
  const formatNumber = (num) => num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const updateCondition = () => {};
  const toggleFieldExpand = () => {};
  const setAllColumnsVisible = () => {};
  const moveColumn = () => {};
  const renderFilterFieldControls = () => null;

  const handleMetricToggle = (metricId) => {
    
    setAnalyticsMetricsState((prev) =>
      prev.map((metric) =>
        metric.id === metricId
          ? { ...metric, selected: !metric.selected }
          : metric
      )
    );

    
    setAdFormatMetricsState((prev) =>
      prev.map((metric) =>
        metric.id === metricId
          ? { ...metric, selected: !metric.selected }
          : metric
      )
    );
  };

  const runReport = (data) => {
    console.log("Run Report:", data);
    setHasRunReportTop(true);
  };

  const setActiveCustomMetric = (idx) => {
    setCustomMetrics((prev) =>
      prev.map((m, i) => ({ ...m, active: i === idx ? !m.active : m.active }))
    );
  };

  const onOpenEditModal = (idx) => {
    setEditingIndex(idx);
    setEditVisible(true);
  };

  const availableMetrics = [
    { id: 'attributed_installs', label: 'Attributed Installs' },
    { id: 'ad_network_installs', label: 'Ad Network Installs' },
    { id: 'impressions', label: 'Impressions' },
    { id: 'clicks', label: 'Clicks' },
    { id: 'cost', label: 'Cost' },
    { id: 'revenue', label: 'Revenue' },
    { id: 'sessions', label: 'Sessions' },
    { id: 'dau', label: 'DAU' }
  ];

  const handleAddMetric = (metric) => {
    setSelectedMetrics(prev => [...prev, metric]);
    setShowMetricDropdown(false);
  };

  const handleAddOperator = (operator) => {
    setSelectedMetrics(prev => [...prev, { id: operator, label: operator }]);
  };

  const handleAddNumber = () => {
    if (numberInput.trim()) {
      setSelectedMetrics(prev => [...prev, { id: 'number', label: numberInput }]);
      setNumberInput('');
      setShowNumberInput(false);
    }
  };

  const handleRemoveMetric = (index) => {
    setSelectedMetrics(prev => prev.filter((_, i) => i !== index));
  };

  const handleClear = () => {
    if (selectedMetrics.length > 0) {
      setSelectedMetrics(prev => prev.slice(0, -1));
    }
  };

  const handleClearAll = () => {
    setSelectedMetrics([]);
  };

  return (
    <>
      <div className="background-second-dashboard">
        <section className="main__content-dashbard">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div className="detail-body">
                      <div className="overview_content pd-20">
                        <div>
                          <div className="mb-6">
                            <FilterForm onSubmit={runReport} />
                          </div>
                          <div className="mb-6">
                            <Collapse
                              onChange={(keys) =>
                                setMetricsExpanded(keys?.includes("1"))
                              }
                            >
                              <Collapse.Panel
                                header={
                                  <span className="metrics-header">
                                    Metrics
                                  </span>
                                }
                                key="1"
                              >
                                <MetricsSection
                                  analyticsMetrics={analyticsMetricsState}
                                  adFormatMetrics={adFormatMetricsState}
                                  onMetricToggle={handleMetricToggle}
                                  rrDays={rrDays}
                                  setRrDays={setRrDays}
                                  iapDays={iapDays}
                                  setIapDays={setIapDays}
                                  adDays={adDays}
                                  setAdDays={setAdDays}
                                  ltvDays={ltvDays}
                                  setLtvDays={setLtvDays}
                                  customMetrics={customMetrics}
                                  setActiveCustomMetric={setActiveCustomMetric}
                                  onOpenEditModal={onOpenEditModal}
                                  setAddVisible={setAddVisible}
                                />
                                <AntButton
                                  type="primary"
                                  onClick={() => setHasRunReportMetrics(true)}
                                  className="run-report-btn"
                                >
                                  Run Report
                                </AntButton>
                              </Collapse.Panel>
                            </Collapse>
                          </div>
                        </div>
                      </div>
                      {(hasRunReportTop || hasRunReportMetrics) && (
                        <div className="table_overview_content pd-20">
                          <TableContainer
                            fields={fields}
                            getVisibleColumns={getVisibleColumns}
                            sortConfig={sortConfig}
                            toggleSort={toggleSort}
                            getFieldLabel={getFieldLabel}
                            hasActiveFilter={hasActiveFilter}
                            handleColumnFilterClick={handleColumnFilterClick}
                            sortedData={sortedData}
                            renderGroup={renderGroup}
                            dataTotal={dataTotal}
                            formatNumber={formatNumber}
                            METRIC_FORMATS={METRIC_FORMATS}
                            columnFilterPopup={columnFilterPopup}
                            columnPopupRef={columnPopupRef}
                            ColumnFilterPopupContent={() => null}
                            filters={filters}
                            updateCondition={updateCondition}
                            onCloseColumnFilterPopup={() => setColumnFilterPopup({ activeColumn: null, position: { top: 0, left: 0 } })}
                            showPopup={showPopup}
                            togglePopup={() => setShowPopup((v) => !v)}
                            fieldsPanel={{}}
                            showFilterPanel={showFilterPanel}
                            setShowFilterPanel={setShowFilterPanel}
                            columnsPanel={{ searchTerm, setSearchTerm, columnOrder, setAllColumnsVisible, ColumnField: null }}
                            headerDrag={{ moveColumn }}
                            setFilters={setFilters}
                            filterableColumns={[]}
                            toggleFieldExpand={toggleFieldExpand}
                            renderFilterFieldControls={renderFilterFieldControls}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal
        title="Update Custom Metric"
        open={editVisible}
        onCancel={() => setEditVisible(false)}
        footer={[
          <AntButton
            key="cancel"
            onClick={() => setEditVisible(false)}
          >
            Cancel
          </AntButton>,
          <AntButton
            key="delete"
            danger
            style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f', color: '#fff' }}
            onClick={() => setEditVisible(false)}
          >
            Delete
          </AntButton>,
          <AntButton
            key="update"
            type="primary"
            onClick={() => setEditVisible(false)}
          >
            Update
          </AntButton>,
        ]}
        width={600}
      >
        <div style={{ padding: '16px 0' }}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              <span style={{ color: '#ff4d4f' }}>*</span> Name:
            </label>
            <Input
              placeholder="Attributed / Ad Network Installs"
              style={{ width: '100%' }}
              disabled
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              Description:
            </label>
            <Input
              placeholder="Description"
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              <span style={{ color: '#ff4d4f' }}>*</span> Data format:
            </label>
            <Select
              defaultValue="Percent (%)"
              style={{ width: '100%' }}
              options={[{ value: "Percent (%)", label: "Percent (%)" }]}
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              <span style={{ color: '#ff4d4f' }}>*</span> Title Color:
            </label>
            <Select
              defaultValue="Black"
              style={{ width: '100%' }}
              options={[
                { 
                  value: "Black", 
                  label: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span>Black</span>
                      <div style={{ width: '12px', height: '12px', backgroundColor: '#000', borderRadius: '2px' }}></div>
                    </div>
                  )
                }
              ]}
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              <span style={{ color: '#ff4d4f' }}>*</span> Background Color:
            </label>
            <ColorPicker
              defaultValue="#000000"
              presets={[
                {
                  label: 'Recommended',
                  colors: [
                    '#000000',
                    '#ffffff',
                    '#ff4d4f',
                    '#1890ff',
                    '#52c41a',
                    '#faad14',
                    '#722ed1',
                    '#eb2f96',
                  ],
                },
              ]}
            />
          </div>
          
          <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', gap: '8px', position: 'relative' }}>
              <div style={{ position: 'relative' }}>
                <AntButton 
                  type="text" 
                  size="small" 
                  style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#1890ff' }}
                  onClick={() => setShowMetricDropdown(!showMetricDropdown)}
                >
                  <PlusOutlined style={{ fontSize: '12px' }} />
                  Add Metric
                </AntButton>
                {showMetricDropdown && (
                  <div style={{
                    position: 'absolute',
                    top: '-200px',
                    left: '0',
                    width: '200px',
                    backgroundColor: 'white',
                    border: '1px solid #d9d9d9',
                    borderRadius: '6px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    maxHeight: '200px',
                    overflowY: 'auto'
                  }}>
                    {availableMetrics.map((metric) => (
                      <div
                        key={metric.id}
                        style={{
                          padding: '8px 12px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #f0f0f0',
                          fontSize: '14px'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                        onClick={() => handleAddMetric(metric)}
                      >
                        {metric.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
              <div style={{ position: 'relative' }}>
                {showNumberInput ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Input
                      value={numberInput}
                      onChange={(e) => setNumberInput(e.target.value)}
                      placeholder="Number"
                      style={{ width: '120px' }}
                      onPressEnter={handleAddNumber}
                      autoFocus
                    />
                    <span 
                      style={{ cursor: 'pointer', color: '#ff4d4f', fontSize: '16px' }}
                      onClick={() => {
                        setShowNumberInput(false);
                        setNumberInput('');
                      }}
                    >
                      ×
                    </span>
                    <span 
                      style={{ cursor: 'pointer', color: '#52c41a', fontSize: '16px' }}
                      onClick={handleAddNumber}
                    >
                      ✓
                    </span>
                  </div>
                ) : (
                  <span 
                    style={{ color: '#666', fontSize: '14px', cursor: 'pointer' }}
                    onClick={() => setShowNumberInput(true)}
                  >
                    Number
                  </span>
                )}
              </div>
              
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('(')}
              >
                (
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator(')')}
              >
                )
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('+')}
              >
                +
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('-')}
              >
                -
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('X')}
              >
                X
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('÷')}
              >
                ÷
              </AntButton>
              
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                <AntButton 
                  type="link" 
                  size="small" 
                  style={{ padding: '0', height: 'auto', color: '#1890ff' }}
                  onClick={handleClear}
                >
                  Clear
                </AntButton>
                <AntButton 
                  type="link" 
                  size="small" 
                  style={{ padding: '0', height: 'auto', color: '#1890ff' }}
                  onClick={handleClearAll}
                >
                  Clear All
                </AntButton>
              </div>
            </div>
            <div style={{ 
              padding: '12px', 
              border: '1px solid #d9d9d9', 
              borderRadius: '6px', 
              backgroundColor: '#fafafa',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexWrap: 'wrap'
            }}>
              {selectedMetrics.length === 0 ? (
                <span style={{ color: '#999', fontStyle: 'italic' }}>Formula will be show here</span>
              ) : (
                selectedMetrics.map((metric, index) => {
                  
                  const isOperator = ['(', ')', '+', '-', 'X', '÷', 'number'].includes(metric.id);
                  
                  return (
                    <div key={index} style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      backgroundColor: isOperator ? '#f0f0f0' : '#e6f7ff',
                      border: isOperator ? '1px solid #d9d9d9' : '1px solid #91d5ff',
                      borderRadius: '16px',
                      padding: '2px 8px',
                      fontSize: '12px',
                      gap: '4px'
                    }}>
                      <span>{metric.label}</span>
                      {!isOperator && (
                        <span 
                          style={{ cursor: 'pointer', color: '#666' }}
                          onClick={() => handleRemoveMetric(index)}
                        >
                          ×
                        </span>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </Modal>

      {/* Add Custom Metric Modal */}
      <Modal
        title="Add Custom Metric"
        open={addVisible}
        onCancel={() => setAddVisible(false)}
        footer={[
          <AntButton
            key="cancel"
            onClick={() => setAddVisible(false)}
          >
            Cancel
          </AntButton>,
          <AntButton
            key="add"
            type="primary"
            onClick={() => {
              
              const newMetric = {
                label: "New Custom Metric",
                active: false
              };
              setCustomMetrics(prev => [...prev, newMetric]);
              setAddVisible(false);
            }}
          >
            Add
          </AntButton>,
        ]}
        width={600}
      >
        <div style={{ padding: '16px 0' }}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              <span style={{ color: '#ff4d4f' }}>*</span> Name:
            </label>
            <Input
              placeholder="Enter metric name"
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              Description:
            </label>
            <Input
              placeholder="Description"
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              <span style={{ color: '#ff4d4f' }}>*</span> Data format:
            </label>
            <Select
              defaultValue="Percent (%)"
              style={{ width: '100%' }}
              options={[{ value: "Percent (%)", label: "Percent (%)" }]}
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              <span style={{ color: '#ff4d4f' }}>*</span> Title Color:
            </label>
            <Select
              defaultValue="Black"
              style={{ width: '100%' }}
              options={[
                { 
                  value: "Black", 
                  label: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span>Black</span>
                      <div style={{ width: '12px', height: '12px', backgroundColor: '#000', borderRadius: '2px' }}></div>
                    </div>
                  )
                }
              ]}
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>
              <span style={{ color: '#ff4d4f' }}>*</span> Background Color:
            </label>
            <ColorPicker
              defaultValue="#000000"
              presets={[
                {
                  label: 'Recommended',
                  colors: [
                    '#000000',
                    '#ffffff',
                    '#ff4d4f',
                    '#1890ff',
                    '#52c41a',
                    '#faad14',
                    '#722ed1',
                    '#eb2f96',
                  ],
                },
              ]}
            />
          </div>
          
          <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', gap: '8px', position: 'relative' }}>
              <div style={{ position: 'relative' }}>
                <AntButton 
                  type="text" 
                  size="small" 
                  style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#1890ff' }}
                  onClick={() => setShowMetricDropdown(!showMetricDropdown)}
                >
                  <PlusOutlined style={{ fontSize: '12px' }} />
                  Add Metric
                </AntButton>
                {showMetricDropdown && (
                  <div style={{
                    position: 'absolute',
                    top: '-200px',
                    left: '0',
                    width: '200px',
                    backgroundColor: 'white',
                    border: '1px solid #d9d9d9',
                    borderRadius: '6px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    maxHeight: '200px',
                    overflowY: 'auto'
                  }}>
                    {availableMetrics.map((metric) => (
                      <div
                        key={metric.id}
                        style={{
                          padding: '8px 12px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #f0f0f0',
                          fontSize: '14px'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                        onClick={() => handleAddMetric(metric)}
                      >
                        {metric.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
              <div style={{ position: 'relative' }}>
                {showNumberInput ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Input
                      value={numberInput}
                      onChange={(e) => setNumberInput(e.target.value)}
                      placeholder="Number"
                      style={{ width: '120px' }}
                      onPressEnter={handleAddNumber}
                      autoFocus
                    />
                    <span 
                      style={{ cursor: 'pointer', color: '#ff4d4f', fontSize: '16px' }}
                      onClick={() => {
                        setShowNumberInput(false);
                        setNumberInput('');
                      }}
                    >
                      ×
                    </span>
                    <span 
                      style={{ cursor: 'pointer', color: '#52c41a', fontSize: '16px' }}
                      onClick={handleAddNumber}
                    >
                      ✓
                    </span>
                  </div>
                ) : (
                  <span 
                    style={{ color: '#666', fontSize: '14px', cursor: 'pointer' }}
                    onClick={() => setShowNumberInput(true)}
                  >
                    Number
                  </span>
                )}
              </div>
              
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('(')}
              >
                (
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator(')')}
              >
                )
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('+')}
              >
                +
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('-')}
              >
                -
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('X')}
              >
                X
              </AntButton>
              <AntButton 
                type="text" 
                size="small" 
                style={{ color: '#666', fontSize: '14px', padding: '4px 8px' }}
                onClick={() => handleAddOperator('÷')}
              >
                ÷
              </AntButton>
              
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                <AntButton 
                  type="link" 
                  size="small" 
                  style={{ padding: '0', height: 'auto', color: '#1890ff' }}
                  onClick={handleClear}
                >
                  Clear
                </AntButton>
                <AntButton 
                  type="link" 
                  size="small" 
                  style={{ padding: '0', height: 'auto', color: '#1890ff' }}
                  onClick={handleClearAll}
                >
                  Clear All
                </AntButton>
              </div>
            </div>
            <div style={{ 
              padding: '12px', 
              border: '1px solid #d9d9d9', 
              borderRadius: '6px', 
              backgroundColor: '#fafafa',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexWrap: 'wrap'
            }}>
              {selectedMetrics.length === 0 ? (
                <span style={{ color: '#999', fontStyle: 'italic' }}>Formula will be show here</span>
              ) : (
                selectedMetrics.map((metric, index) => {
                  
                  const isOperator = ['(', ')', '+', '-', 'X', '÷', 'number'].includes(metric.id);
                  
                  return (
                    <div key={index} style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      backgroundColor: isOperator ? '#f0f0f0' : '#e6f7ff',
                      border: isOperator ? '1px solid #d9d9d9' : '1px solid #91d5ff',
                      borderRadius: '16px',
                      padding: '2px 8px',
                      fontSize: '12px',
                      gap: '4px'
                    }}>
                      <span>{metric.label}</span>
                      {!isOperator && (
                        <span 
                          style={{ cursor: 'pointer', color: '#666' }}
                          onClick={() => handleRemoveMetric(index)}
                        >
                          ×
                        </span>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ReleaseIntel;
